import { makeStyles } from '@mui/styles';
import { colors, fonts } from 'components/styles/variables';
import { theme } from 'components/Shared/ThemeProviderWrapper';

export const useStyles = makeStyles({
  filtersModal: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  paper: {
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      width: '360px',
      right: 0,
    },
  },

  modalHeader: {
    backgroundColor: colors.WHITE,
    position: 'sticky',
    top: 0,
    zIndex: 20,
    borderBottom: `1px solid ${colors.G2}`,
  },

  headerTopRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '16px',
  },

  headerTitle: {
    color: colors.BLACK,
    fontFamily: fonts.default,
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '32px',
    letterSpacing: '0.2px',
    textTransform: 'none',
  },

  saveSearchButton: {
    '&.MuiButton-root': {
      backgroundColor: colors.ALR1,
    },
    '&.MuiButton-text': {
      color: colors.WHITE,
    },
    '&:hover': {
      backgroundColor: colors.ALR2,
    },
    fontFamily: fonts.default,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.2px',
    textTransform: 'none',
    width: 'calc((100% - 48px) / 2)',
    borderRadius: '4px',
  },

  filtersListOuter: {
    overflow: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },

  filtersList: {
    backgroundColor: colors.G1,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'flex-start',
    padding: '16px',
  },

  modalFooter: {
    backgroundColor: colors.WHITE,
    width: '100%',
    position: 'sticky',
    bottom: 0,
    borderTop: `1px solid ${colors.G2}`,
    height: '68px',
  },
});
